import { render, staticRenderFns } from "./UnsavedForm.vue?vue&type=template&id=bc5f90b6&"
import script from "./UnsavedForm.vue?vue&type=script&lang=ts&"
export * from "./UnsavedForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports